<template>
  <div class="course-detail">
    <!-- 课程头部信息 -->
    <div class="course-header">
      <div class="header-left">
        <div class="course-badge">精品课程</div>
        <span :class="['type-badge', types == 1 ? 'live-badge' : 'record-badge']">
          {{ types == 1 ? '直播课' : types == 2 ? '录播课' : '' }}
        </span>
        <div class="course-title">{{ courseName || '《中国现代文学史》' }}</div>
      </div>
      <div class="header-right">
        <el-button v-if="courseDocFlag == 1" class="btn-outline" @click="handleCourseMaterial">课程资料</el-button>
        <el-button v-if="courseTestFlag == 1" class="btn-outline" @click="handleCourseTest">课程测试</el-button>
      </div>
    </div>

    <!-- 课程统计信息 -->
    <div class="course-stats">
      <span class="stat-item">共{{ chapterCount }}章{{ lessonCount }}课时</span>
      <span class="stat-item">学习率：{{ studyRate }}%</span>
      <div class="collapse-btn" @click="toggleAllChapters">
        {{ allExpanded ? '收起' : '展开' }}
        <img :src="allExpanded ? 'https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/101.png' : 'https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/100.png'" alt="" class="arrow-icon">
      </div>
    </div>

    <!-- 章节列表 -->
    <div class="chapter-list">
      <div v-for="(chapter, index) in displayChapterList" :key="chapter.id || index" class="chapter-item">
        <!-- 章节目题 -->
        <div class="chapter-header" @click="toggleChapter(chapter)">
          <div class="chapter-left">
            <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/93.png" alt="" class="chapter-icon">
            <span class="chapter-name">{{ chapter.name }}</span>
          </div>
          <div class="chapter-right">
            <span class="chapter-expand">{{ chapter.expanded ? '展开' : '收起' }}</span>
            <img :src="chapter.expanded ? 'https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/101.png' : 'https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/100.png'" alt="" class="arrow-icon">
          </div>
        </div>

        <!-- 课时列表 - 直播课样式 -->
        <div v-show="chapter.expanded && types == 1" class="lesson-list live-lesson-list">
          <div v-for="(lesson, lessonIndex) in chapter.lessons" :key="lesson.id || lessonIndex" class="lesson-item live-lesson-item">
            <div class="live-lesson-left-wrapper">
              <div class="live-lesson-top">
                <span class="video-icon">
                  <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/97.png" alt="">
                </span>
                <span class="lesson-name">{{ lesson.name }}</span>
                <span class="video-tag">
                  <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/95.png" alt="">
                  回放
                </span>
              </div>
              <div class="live-lesson-bottom">
                <span class="lesson-time" v-if="lesson.startTime">🕐 {{ formatDate(lesson.startTime) }}</span>
                <div class="progress-bar">
                  <div class="progress-fill" :style="{ width: lesson.studyRate + '%' }"></div>
                </div>
                <span class="status-tag">{{ lesson.studyRate >= 100 ? '已完成' : '学习中' }}</span>
              </div>
            </div>
            <div class="live-lesson-right">
              <el-button v-if="lesson.teachList && lesson.teachList.length > 0" class="action-btn" @click="handleLessonMaterial(lesson)">随堂讲义</el-button>
              <el-button v-if="lesson.testList && lesson.testList.length > 0" class="action-btn" @click="handleLessonTest(lesson)">随堂测试</el-button>
              <el-button v-if="lesson.resourceList && lesson.resourceList.length > 0" class="action-btn" @click="handleLessonResource(lesson)">随堂资料</el-button>
              <el-button class="study-btn" @click="handleStudyLesson(lesson)">去学习</el-button>
            </div>
          </div>
        </div>
        
        <!-- 课时列表 - 录播课样式 -->
        <div v-show="chapter.expanded && types != 1" class="lesson-list">
          <div v-for="(lesson, lessonIndex) in chapter.lessons" :key="lesson.id || lessonIndex" class="lesson-item">
            <div class="lesson-left">
              <div class="lesson-header">
                <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/97.png" alt="" class="lesson-icon">
                <span class="lesson-name">{{ lesson.name }}</span>
              </div>
              <div class="progress-container">
                <div class="progress-bar">
                  <div class="progress-fill" :style="{ width: lesson.studyRate + '%' }"></div>
                  <img v-if="lesson.studyRate >= 100" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/99.png" alt="" class="complete-icon">
                </div>
                <span class="progress-text" :class="{ complete: lesson.studyRate >= 100 }">
                  {{ lesson.studyRate >= 100 ? '已完成' : lesson.studyRate + '%' }}
                </span>
              </div>
            </div>
            <div class="lesson-right">
              <div class="lesson-actions">
                <el-button v-if="lesson.teachList && lesson.teachList.length > 0" class="btn-outline" @click="handleLessonMaterial(lesson)">随堂讲义</el-button>
                <el-button v-if="lesson.testList && lesson.testList.length > 0" class="btn-outline" @click="handleLessonTest(lesson)">随堂测试</el-button>
                <el-button class="btn-primary" @click="handleStudyLesson(lesson)">去学习</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { selectStuCourseChapterDetails, selectChapterRateBykeIdStudentIdGroupId } from '@/api/mykecheng';
import { getInfo } from '@/api/cookies';
export default {
  name: "CourseDetail",
  props: {
    courseName: {
      type: String,
      default: ''
    },
    courseId: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: [String, Number],
      default: 3
    },
    types: {
      type: [String, Number],
      default: ''
    },
    studentId: {
      type: [String, Number],
      default: ''
    },
    courseDocFlag: {
      type: [String, Number],
      default: 0
    },
    courseTestFlag: {
      type: [String, Number],
      default: 0
    },
    chapterList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chapterCount: 0,
      lessonCount: 0,
      studyRate: 0,
      allExpanded: false,
      internalChapterList: [],
      defaultChapterList: []
    };
  },
  computed: {
    displayChapterList() {
      if (this.internalChapterList && this.internalChapterList.length > 0) {
        return this.internalChapterList;
      }
      if (this.chapterList && this.chapterList.length > 0) {
        return this.chapterList;
      }
      return this.defaultChapterList;
    }
  },
  created() {
    if (this.courseId) {
      this.fetchChapterDetails();
    }
  },
  mounted() {
    if (this.courseId) {
      this.fetchChapterDetails();
    }
  },
  watch: {
    courseId: {
      handler(newVal) {
        if (newVal) {
          this.fetchChapterDetails();
        }
      },
      immediate: true
    }
  },
  methods: {
    async fetchChapterDetails() {
      try {
        const userInfo = getInfo();
        const params = {
          courseId: this.courseId,
          type: this.type,
          types: this.types,
          studentId: this.studentId || userInfo?.id
        };
        
        const res = await selectStuCourseChapterDetails(params);
        if (res.code === 0 && res.data) {
          this.transformData(res.data);
        }
      } catch (error) {
        console.error('获取章节详情失败:', error);
      }
    },
    transformData(apiData) {
      this.internalChapterList = [];
      let totalLessons = 0;
      let totalStudyRate = 0;
      let chapterCount = 0;

      apiData.forEach((chapter) => {
        chapterCount++;
        const transformedChapter = {
          id: chapter.id,
          name: chapter.name,
          expanded: false,
          isshow: chapter.isshow || false,
          lessons: [],
          gchapterVOList: []
        };

        if (chapter.gchapterVOList && chapter.gchapterVOList.length > 0) {
          chapter.gchapterVOList.forEach((lesson) => {
            totalLessons++;
            totalStudyRate += lesson.studyRate || 0;
            transformedChapter.lessons.push({
              id: lesson.id,
              name: lesson.name,
              studyRate: lesson.studyRate || 0,
              videoConfig: lesson.videoConfig,
              courseId: lesson.courseId,
              groupId: chapter.id,
              teachList: lesson.teachList,
              testList: lesson.testList,
              resourceList: lesson.resourceList,
              startTime: lesson.startTime
            });
          });
        } else if (chapter.teachList || chapter.testList || chapter.resourceList) {
          totalLessons++;
          totalStudyRate += chapter.studyRate || 0;
          transformedChapter.lessons.push({
            id: chapter.id,
            name: chapter.name,
            studyRate: chapter.studyRate || 0,
            videoConfig: chapter.videoConfig,
            courseId: chapter.courseId,
            groupId: chapter.id,
            teachList: chapter.teachList,
            testList: chapter.testList,
            resourceList: chapter.resourceList,
            isLiveStatus: chapter.isLiveStatus,
            isLive: chapter.isLive,
            startTime: chapter.startTime
          });
        }

        this.internalChapterList.push(transformedChapter);
      });

      this.chapterCount = chapterCount;
      this.lessonCount = totalLessons;
      this.studyRate = totalLessons > 0 ? Math.round(totalStudyRate / totalLessons) : 0;
    },
    async toggleChapter(chapter) {
      chapter.expanded = !chapter.expanded;
      // 如果是录播课并且是展开状态，并且还没有加载过节数据，则调用接口获取节数据
      if (chapter.expanded && this.types !== 1 && chapter.gchapterVOList.length === 0) {
        try {
          const userInfo = getInfo();
          const res = await selectChapterRateBykeIdStudentIdGroupId({
            keId: this.courseId,
            groupId: chapter.id,
            studentId: this.studentId || userInfo?.id
          });
          if (res.code === 0 && res.msg) {
            // 将获取到的节数据转换为lessons格式
            chapter.gchapterVOList = res.msg;
            chapter.lessons = res.msg.map((lesson) => ({
              id: lesson.id,
              name: lesson.name,
              studyRate: lesson.studyRate || 0,
              videoConfig: lesson.videoConfig,
              courseId: lesson.courseId,
              groupId: chapter.id,
              teachList: lesson.teachList,
              testList: lesson.testList,
              resourceList: lesson.resourceList,
              startTime: lesson.startTime
            }));
          }
        } catch (error) {
          console.error('获取节数据失败:', error);
        }
      }
    },
    toggleAllChapters() {
      this.allExpanded = !this.allExpanded;
      this.displayChapterList.forEach(chapter => {
        chapter.expanded = this.allExpanded;
      });
    },
    handleCourseMaterial() {
      this.$emit('course-material');
    },
    handleCourseTest() {
      this.$emit('course-test');
    },
    handleLessonMaterial(lesson) {
      this.$emit('lesson-material', lesson);
    },
    handleLessonTest(lesson) {
      this.$emit('lesson-test', lesson);
    },
    handleStudyLesson(lesson) {
      this.$emit('study-lesson', lesson);
    },
    handleLessonResource(lesson) {
      this.$emit('lesson-resource', lesson);
    },
    formatDate(time) {
      if (!time) return '';
      const date = new Date(time.replace(/-/g, '/'));
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}.${month}.${day} ${hours}:${minutes}`;
    }
  }
};
</script>

<style lang="less" scoped>
.course-detail {
  width: 100%;
  background: #fff;
  border-radius: 4px;
  padding: 16px;

  .course-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    .header-left {
      display: flex;
      align-items: center;
      gap: 8px;

      .course-badge {
        background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
        color: #fff;
        font-size: 12px;
        padding: 4px 12px;
        border-radius: 4px 0 4px 0;
        font-weight: 500;
      }

      .type-badge {
        display: inline-block;
        padding: 2px 8px;
        border-radius: 2px;
        font-size: 12px;
        font-weight: 500;

        &.live-badge {
          background: rgba(255, 107, 0, 0.1);
          color: #ff6b00;
          border: 1px solid #ff6b00;
        }

        &.record-badge {
          background: rgba(74, 106, 240, 0.1);
          color: #4a6af0;
          border: 1px solid #4a6af0;
        }
      }

      .course-title {
        font-size: 18px;
        font-weight: 600;
        color: #333;
      }
    }

    .header-right {
      display: flex;
      gap: 12px;

      .btn-outline {
        padding: 6px 16px;
        border: 1px solid #4a6af0;
        color: #4a6af0;
        background: #fff;
        border-radius: 4px;
        font-size: 13px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          background: #4a6af0;
          color: #fff;
        }
      }
    }
  }

  .course-stats {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-bottom: 16px;
    padding-left: 8px;

    .stat-item {
      font-size: 13px;
      color: #666;
    }

    .collapse-btn {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 13px;
      color: #666;
      cursor: pointer;
      margin-left: auto;

      .arrow-icon {
        width: 13px;
        height: 10px;
      }
    }
  }

  .chapter-list {
    .chapter-item {
      margin-bottom: 0;

      .chapter-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 12px;
        background: #F3F7FA;
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: #e9f0f8;
        }

        .chapter-left {
          display: flex;
          align-items: center;
          gap: 8px;

          .chapter-icon {
            width: 16px;
            height: 10px;
          }

          .chapter-name {
            font-size: 15px;
            font-weight: bold;
            color: #2D6BEF;
          }
        }

        .chapter-right {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 13px;
          color: #666;

          .arrow-icon {
            width: 13px;
            height: 10px;
          }
        }
      }

      .lesson-list {
        .lesson-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px;
          border-bottom: 1px dashed #e0e0e0;

          &:last-child {
            border-bottom: none;
          }

          .lesson-left {
            display: flex;
            flex-direction: column;
            gap: 8px;
            flex: 1;

            .lesson-header {
              display: flex;
              align-items: center;
              gap: 8px;
            }

            .lesson-icon {
              width: 21px;
              height: 17px;
            }

            .lesson-name {
              font-size: 14px;
              color: #333;
            }

            .progress-container {
              display: flex;
              align-items: center;
              gap: 8px;

              .progress-bar {
                width: 500px;
                height: 6px;
                background: #e0e0e0;
                border-radius: 3px;
                overflow: hidden;
                position: relative;

                .progress-fill {
                  height: 100%;
                  background: #4a6af0;
                  border-radius: 3px;
                  transition: width 0.3s;
                }

                .complete-icon {
                  position: absolute;
                  right: -6px;
                  top: -4px;
                  width: 14px;
                  height: 14px;
                }
              }

              .progress-text {
                font-size: 13px;
                color: #4a6af0;
                white-space: nowrap;

                &.complete {
                  color: #4a6af0;
                }
              }
            }
          }

          .lesson-right {
            display: flex;
            align-items: center;

            .lesson-actions {
              display: flex;
              gap: 12px;

              .btn-outline {
                padding: 4px 12px;
                border: 1px solid #4a6af0;
                color: #4a6af0;
                background: #fff;
                border-radius: 4px;
                font-size: 13px;
                cursor: pointer;
                transition: all 0.3s;

                &:hover {
                  background: #4a6af0;
                  color: #fff;
                }
              }

              .btn-primary {
                padding: 10px 17px;
                background: #1C81F5;
                color: #fff;
                border: none;
                border-radius: 17px;
                font-size: 16px;
                cursor: pointer;
                transition: all 0.3s;

                &:hover {
                  background: #3a5ae0;
                }
              }
            }
          }
        }
      }
      
      /* 直播课课时列表样式 */
      .live-lesson-list {
        .live-lesson-item {
          padding: 12px;
          background: #f8f9fa;
          border-bottom: 1px dotted #ccc;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: stretch;

          .live-lesson-left-wrapper {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .live-lesson-top {
            display: flex;
            align-items: center;
            gap: 8px;

            .video-icon {
              font-size: 16px;

              img {
                width: 21px;
                height: 17px;
              }
            }

            .lesson-name {
              font-size: 14px;
              color: #333;
            }

            .video-tag {
              font-size: 11px;
              color: #2E2E2E;
              border-radius: 2px;
              width: 61px;
              height: 17px;
              background: url(https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/94.png) no-repeat center center;
              background-size: 100% 100%;
              display: flex;
              align-items: center;
              justify-content: center;

              img {
                width: 15px;
                height: 9px;
                margin-right: 3px;
              }
            }
          }

          .live-lesson-bottom {
            display: flex;
            align-items: center;
            gap: 12px;

            .lesson-time {
              font-size: 12px;
              color: #666;
              white-space: nowrap;
            }

            .progress-bar {
              flex: 1;
              height: 6px;
              background: #e0e0e0;
              border-radius: 3px;
              overflow: hidden;
              min-width: 120px;

              .progress-fill {
                height: 100%;
                background: #4a6af0;
                border-radius: 3px;
                transition: width 0.3s;
              }
            }

            .status-tag {
              font-size: 12px;
              color: #666;
              white-space: nowrap;
            }
          }

          .live-lesson-right {
            display: flex;
            gap: 8px;
            align-items: center;
            margin-left: 20px;
            width: 350px;
            justify-content: flex-end;

            .action-btn {
              padding: 4px 14px;
              border: 1px solid #4a6af0;
              color: #4a6af0;
              background: #fff;
              border-radius: 2px;
              font-size: 12px;
              cursor: pointer;
              transition: all 0.3s;

              &:hover {
                background: #4a6af0;
                color: #fff;
              }
            }

            .study-btn {
              padding: 10px 17px;
              border: none;
              color: #fff;
              background: #1C81F5;
              border-radius: 17px;
              font-size: 16px;
              cursor: pointer;
              transition: all 0.3s;

              &:hover {
                background: #3a5ae0;
              }
            }
          }

          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>
